"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.finalPaymentStatus = void 0;
const enums_1 = require("./enums");
exports.finalPaymentStatus = [
    enums_1.PaymentStatus.CAPTURED,
    enums_1.PaymentStatus.CANCELED,
    enums_1.PaymentStatus.FAILED,
    enums_1.PaymentStatus.REFUSED,
    enums_1.PaymentStatus.REFUNDED
];
//# sourceMappingURL=vocabularies.js.map